// `usePageContext` allows us to access `pageContext` in any React component.
// See https://vite-plugin-ssr.com/pageContext-anywhere

import { createContext, useContext } from 'react';
import type { PageContext } from './types';

/**
 * Context for page.
 */
const Context = createContext<PageContext>(null as never);

/**
 * Props del PageContextProvider.
 */
type PageContextProviderProps = {
  /**
   * Page context.
   */
  pageContext: PageContext;
  /**
   * Page content.
   */
  children: React.ReactNode;
};

/**
 * Provider para l contexto de la pagina.
 *
 * @param props Page context and page children.
 * @param props.pageContext Page context.
 * @param props.children Page children.
 * @returns Component con context.
 */
const PageContextProvider = ({ pageContext, children }: PageContextProviderProps): JSX.Element => {
  return <Context.Provider value={pageContext}>{children}</Context.Provider>;
};

/**
 * Page context hook.
 *
 * @returns Page context.
 */
export function usePageContext(): PageContext {
  /**
   * Page context.
   */
  const pageContext = useContext(Context);
  return pageContext;
}

export { PageContextProvider };
